import { render, staticRenderFns } from "./BindWeChat.vue?vue&type=template&id=a8da2ae8&scoped=true"
import script from "./BindWeChat.vue?vue&type=script&lang=js"
export * from "./BindWeChat.vue?vue&type=script&lang=js"
import style0 from "./BindWeChat.vue?vue&type=style&index=0&id=a8da2ae8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8da2ae8",
  null
  
)

export default component.exports